module.exports = __webpack_public_path__ + "img/Music.72a58713.png";